module.exports = __webpack_public_path__ + "img/Grooms-Init.b84be157.svg";